<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <!-- <el-button type="primary" icon="el-icon-edit" @click.native="handleInput(null,null)">添加</el-button> -->
                <el-button type="primary" icon="el-icon-edit" @click.native="handleForm(null, null)">添加</el-button>
            </el-form-item>

            <el-form-item>
                <el-date-picker v-model="servetime" type="datetimerange" :picker-options="pickerOptions"
                    range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" align="left"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']" @change="dateChange"></el-date-picker>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input placeholder="服务标题" v-model="query.servetitle" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column label="选择" prop="serveid" type="selection" :show-overflow-tooltip="true" width="50"
                align="center" />
            <el-table-column label="序列号" align="center" width="150" prop="servesort" />
            <el-table-column label="服务标题" align="center" :show-overflow-tooltip="true" prop="servetitle" />

            <el-table-column label="添加时间" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span>{{
            scope.row.servetime | formatDateStr("yyyy-MM-dd hh:mm:ss")
          }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="handleInfo(scope.$index, scope.row)">查看
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button v-if="scope.row.serveline == 1" type="primary" size="mini"
                        @click.native="handleDown(scope.row.serveid)">下架</el-button>
                    <el-button v-if="scope.row.serveline == 0" type="primary" size="mini"
                        @click.native="handleUp(scope.row.serveid)">上架</el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.row.serveid)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <el-pagination class="pagination-container" background :page-size="query.pageSize"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>
        <!-- </el-scrollbar> -->
        <!--表单-->

        <!---- 增加  --->
        <!-- <el-dialog
            :visible.sync="formInput"
            :before-close="hideFormInput"
            width="800px"
            top="5vh"
            v-dialogDrag
        >
            <el-form :model="formData" :rules="formRules" ref="dataForm" >

                <el-form-item label="标题:" prop="servetitle" >
                    <el-input v-model="formData.servetitle" clearable></el-input>
                </el-form-item>
                <el-form-item label="序列号:" prop="servesort" >
                    <el-input v-model="formData.servesort" clearable></el-input>
                </el-form-item>
                <el-form-item label="封面图:" prop="serveurl">
                    <el-upload
                        v-show="pic_is_show"
                        class="avatar-uploader"
                        style="margin-bottom: 15px;"
                        accept=".png, .jpg, .gif, .jpeg, .bmp"
                        :action="uploadUrl"
                        :headers="{'hfmauth':'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                    >
                        <img v-if="formData.serveurl" :src="formData.serveurl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="详情:" prop="servedetail">

                    <tinymce
                        style="display: inline-block;width: 100%;"
                        ref="tinymce"
                        :height="500"
                        v-model="formData.servedetail"
                    />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">

                <el-button @click.native="hideFormInput">取消</el-button>
                <el-button type="primary" @click.native="formSubInput" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog> -->

        <!-- 编辑 -->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="800px"
            top="5vh" v-dialogDrag>
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="标题:" prop="servetitle">
                    <el-input v-model="formData.servetitle" clearable></el-input>
                </el-form-item>
                <el-form-item label="序列号:" prop="servesort">
                    <el-input v-model="formData.servesort" clearable></el-input>
                </el-form-item>
                <el-form-item label="封面图:" prop="serveurl">
                    <el-upload v-show="pic_is_show" class="avatar-uploader" style="margin-bottom: 15px;"
                        accept=".png, .jpg, .gif, .jpeg, .bmp" :action="uploadUrl"
                        :headers="{ hfmauth : 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }" :show-file-list="false"
                        :on-success="handleAvatarSuccess">
                        <img v-if="formData.serveurl" :src="formData.serveurl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>

                <el-form-item label="详情:" prop="">
                    <tinymce style="display: inline-block;width: 100%;" ref="tinymce" :height="300"
                        v-model="formData.servedetail" />
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--  查看 --->
        <el-dialog title="查看" :visible.sync="formInfo" :before-close="hideInfo" width="800px" top="5vh" v-dialogDrag>
            <el-form :model="formData">
                <el-form-item label="标题:" prop="servetitle">
                    <input v-model="formData.servetitle" type="text" readonly />
                </el-form-item>
                <el-form-item label="序列号:" prop="servetitle">
                    <input v-model="formData.servesort" type="text" readonly />
                </el-form-item>

                <el-form-item label="详情:" prop="servedetail">
                    <div v-html="formData.servedetail"></div>
                </el-form-item>

                <el-form-item label="封面图:" prop="servedetail">
                    <el-popover v-if="formData.serveurl!=null" placement="right" trigger="hover"
                        style="margin-right:5px;">
                        <img :src="formData.serveurl" style="width:400px;border-radius:3px;">
                        <img slot="reference" :src="formData.serveurl"
                            style="height: 150px;width: 150px;border-radius:5px;">
                    </el-popover>
                    <span v-else>
                        暂无封面图
                    </span>
                </el-form-item>

            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        listService,
        deleteService,
        addSysMsg,
        updateSysMsg,
        upDownService
    } from "../../api/product/service.js";
    import Tinymce from "../../components/Tinymce/index.vue";
    import {
        formatDateStr
    } from "../../filtres/index";
    import {
        BASE_URL
    } from "../../config/app";
    const formJson = {
        serveid: "",
        servetitle: "",
        servesort: "",
        servetime: "",
        servedetail: "",
        serveline: "",
        serveurl: ""
    };
    export default {
        data() {
            var checkTitle = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入标题"));
                } else {
                    callback();
                }
            };
            var checkSort = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入序列号"));
                } else {
                    var reg = /^[0-9]*$/;
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error("请输入正整数"));
                    }
                }
            };
            var checkUrl = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请上传封面图"));
                } else {
                    callback();
                }
            };
            var checkDetail = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入详情"));
                } else {
                    callback();
                }
            };

            return {
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions: {
                    shortcuts: [{
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近六个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                cancelToggle: false,
                servetime: [],
                pushtime: "",
                query: {
                    servetitle: "",
                    startTime: "",
                    endTime: "",
                    currentPage: 1,
                    pageSize: 10
                },
                formMap: {
                    add: "添加",
                    edit: "编辑",
                    detail: "查看"
                },
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formLoading: false,
                formVisible: false,
                formInfo: false,
                formInput: false,
                formData: formJson,
                formRules: {
                    servetitle: [{
                        validator: checkTitle,
                        trigger: "blur"
                    }],
                    servesort: [{
                        validator: checkSort,
                        trigger: "blur"
                    }],
                    /*serveurl: [{ validator: checkUrl, trigger: "blur" }],*/
                    servedetail: [{
                        validator: checkDetail,
                        trigger: "blur"
                    }]
                },
                multipleSelection: [], //多选集合
                uploadUrl: BASE_URL + "/upload/tool/uploadpro",
                pic_is_show: true
            };
        },

        components: {
            Tinymce
        },
        methods: {
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.listService();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.serveid).join(); //获取所有选中行的id组成的字符串，以逗号分隔

                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.servetime = [];
                this.listService();
            },
            onSubmit() {
                this.$router.push({
                    path: "",
                    query: this.query
                });
                this.listService();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.listService();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.listService();
            },
            listService() {
                this.loading = true;
                listService(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }

                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                this.$refs["dataForm"].resetFields();
                this.$refs.tinymce.clearContent();
                return true;
            },
            hideFormInput() {
                // 更改值
                this.formInput = !this.formInput;
                return true;
            },

            hideInfo() {
                // 更改值
                this.formInfo = !this.formInfo;
                // 清空表单
                // this.$refs["dataForm"].resetFields();
                // this.$refs.tinymce.clearContent();
                // this.query.servetitle = "";
                return true;
            },
            hideInput() {
                // 更改值
                this.formInput = !this.formInput;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.query.servetitle = "";
                return true;
            },
            // 显示表单
            // handleForm(index, row){
            //     this.formVisible = true;
            //     this.formData = Object.assign({}, formJson);
            //     if (row !== null) {
            //         this.formData = Object.assign({}, row);
            //     }
            //     this.formName="detail";
            //     //编辑
            //     if (index !== null) {
            //         this.index = index;
            //         row.pushtime = formatDateStr(row.pushtime ,'yyyy-MM-dd hh:mm:ss')

            //         this.formData = row;
            //         let vm = this;
            //         setTimeout(function() {
            //             vm.$nextTick(() => {
            //                 if (vm.$refs.tinymce) {
            //                     vm.$refs.tinymce.setContent(
            //                         vm.formData.problemanswer
            //                     );
            //                 }
            //             });
            //         }, 350);
            //     }

            //     // 清空验证信息表单
            //     if (this.$refs["dataForm"]) {
            //         this.$refs["dataForm"].clearValidate();
            //     }

            // },
            handleForm(index, row) {
                this.formVisible = true;
                //this.$refs.clearFile.value = '';
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                this.formName = "add";
                //编辑
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                    this.statu = 0;
                    let vm = this;
                    setTimeout(function () {
                        vm.$nextTick(() => {
                            if (vm.$refs.tinymce) {
                                vm.$refs.tinymce.setContent(
                                    row.servedetail
                                );
                            }
                        });
                    }, 10);

                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },

            // handleInput(index, row) {
            //   this.formInput = true;
            //   this.formData = Object.assign({}, formJson);
            //   if (row !== null) {
            //     this.formData = Object.assign({}, row);
            //   }
            //   //编辑
            //   if (index !== null) {
            //     this.index = index;
            //     let vm = this;
            //     setTimeout(function() {
            //       vm.$nextTick(() => {
            //         if (vm.$refs.tinymce) {
            //           vm.$refs.tinymce.setContent(vm.formData.problemanswer);
            //         }
            //       });
            //     }, 350);
            //   }
            //   // 清空验证信息表单
            //   if (this.$refs["dataForm"]) {
            //     this.$refs["dataForm"].clearValidate();
            //   }
            // },

            handleInfo(index, row) {
                this.formInfo = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        this.formData.servetime = "";
                        //let data = new URLSearchParams(this.formData);
                        let data = Object.assign({}, this.formData);
                        console.log(data);
                        updateSysMsg(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            //this.$refs.tinymce.clearContent();
                            this.formVisible = false;
                            this.query.servetitle = "";
                            this.listService();
                        });
                    }
                });
            },

            formSubInput() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        let data = Object.assign({}, this.formData);
                        console.log(data);
                        addSysMsg(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            //this.$refs["dataForm"].resetFields();
                            //this.$refs.tinymce.clearContent();
                            this.formInput = false;
                            this.query.servetitle = "";
                            this.listService();
                        });
                    }
                });
            },
            //下架
            handleDown(id) {
                if (id) {
                    this.$confirm("确认要下架该服务?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            var params = new URLSearchParams();
                            params.append("serveid", id);
                            params.append("serveline", 0);
                            upDownService(params)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("下架成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.listService();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            },
            //上架
            handleUp(id) {
                if (id) {
                    this.$confirm("确认要上架该服务?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            var params = new URLSearchParams();
                            params.append("serveid", id);
                            params.append("serveline", 1);
                            upDownService(params)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("上架成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.listService();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            },
            handleAvatarSuccess(res, file) {
                this.formData.serveurl = res.data;
                console.info(res);
                console.info(file);
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            var params = new URLSearchParams();
                            params.append("ids", ids);
                            deleteService(params)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.listService();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            }
        },

        mounted() {},
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.listService();
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
  margin: 0;
}
.app_logo {
  width: 150px;
  height: 150px;
  border-radius: 5px;
  max-width: 150px;
  max-height: 150px;
}
.loading_div {
  width: 150px;
  height: 150px;
  border-radius: 5px;
  max-width: 150px;
  max-height: 150px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
//  .el-tooltip {
//     text-align: left;
// }
</style>
